<template>
    <div class="form-slider">
      <v-container v-if="imageSlider">
        <v-row>
          <v-file-input
            v-model="files"
            class="input"
            chips
            :placeholder="placeHolder"
            :rules="rules1"
            accept="image/png, image/jpeg, image/bmp"
            prepend-icon="mdi-camera"
          ></v-file-input>
          <p class="text">عکس مورد نظر خود را اپلود کنید</p>
        </v-row>
      </v-container>
      <div v-if="dateSlider" class="date-input">
        <date-picker
          v-model="date"
          placeholder="تاریخ مورد نظر خود را وارد نمایید"
          color="#E72480"
        >

        </date-picker>
      </div>
      <div style="display: flex;justify-content: flex-start;align-items: flex-start">
        <div style="font-weight: bold;margin: 15px 0 15px 15px;">عنوان اسلاید:</div>
      <v-text-field
        class="title-input"
        style="max-width: 300px;width: 300px"
        label="عنوان"
        :rules="rule"
        v-model="editData.title"
        placeholder="عنوان"
        v-if="titleSlider"
        solo
      ></v-text-field>
      </div>
      <v-textarea
        class="text-input"
        v-if="textSlider"
        counter
        label="متن اسلایدر مورد نظر را وارد کنید"
        row-height="5"
        :rules="rules"
        v-model="editData.text"
        rows="2"
      ></v-textarea>
      <div style="display: flex;justify-content: flex-start;align-items: flex-start">
        <div style="font-weight: bold;margin: 15px 0 15px 15px;">لینک به کجا برود ؟‌</div>
      <div v-if="linkSlider" class="link-input">
        <v-select
          :items="items"
          label="لینک به کجا برود ؟‌"
          solo
          v-model="editData.link"
        ></v-select>
      </div>
      </div>
    </div>
</template>

<script>
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  export default {
        name: "formSlider",
        components:{
          datePicker: VuePersianDatetimePicker

        },
         props:{
           edit: Boolean,
           editData: Object,
           imageSlider: Boolean,
           textSlider:Boolean,
           titleSlider:Boolean,
           dateSlider:Boolean,
           linkSlider:Boolean,
         },
    data: function(){
      return{
        placeHolder :'عکس اسلایدر مورد نظر',
        rule: [v => v.length <= 50 || `متن وارد شده باید کمتر از ${50} کاراکتر باشد`],
        rules: [v => v.length <= 160 || `متن وارد شده باید کمتر از ${160} کاراکتر باشد`],
        textValue: '',
        value: '',
        files:[],
        date:'',
        select:'',
        items: [ '' ,'فروشگاه ها', 'امکانات', 'باشگاه مشتریان', 'اخبار و اطلاعیه ها', 'راهنمای طبقات', 'خرید و اجاره'],
        rules1: [
          value => !value || value.size < 50000000 || 'عکس مورد نظر باید کمتر از 50 مگابایت اندازه داشته باشد',
        ],
      }

    },
      methods :{
      },
    updated () {
          this.$store.state.firstSliderMainPage.slider.text = this.editData.text
          this.$store.state.firstSliderMainPage.slider.buttonLink = this.editData.link
          this.$store.state.firstSliderMainPage.slider.title = this.editData.title
          this.$store.state.ruleMainPage = this.editData.text.length <= 160 && this.editData.title.length<=50 && this.editData.title.length!==0 &&this.editData.link.length!==0 && this.editData.text.length !== 0
      },


    }
</script>
<style>
  .text-input .v-label.v-label  {
    font-size: 1.1rem !important;
    top: 0;
  }
  .text-input .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
    height: 2rem !important;
  }
  .text-input .v-textarea textarea{
    font-size: 1.25rem;
  }
  .date-input{
    margin-bottom: 2rem;
  }
</style>
<style scoped>
  .form-slider{
    display: flex;
    flex-direction: column;
    max-width: 1185px;
    margin: 0 auto;
  }
  .title-input
  {
    min-height: unset;
  }
  .input{
    direction: ltr;
  }
  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .link-input{
    width: 40%;
  }

</style>
